"use client";

import { Button } from "@/components/shadcn/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/shadcn/dialog";
import { useRouter } from "@/i18n/navigation";
import { useTranslations } from "next-intl";

interface PremiumRequiredModalProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
}

export function PremiumRequiredModal({
    open,
    onOpenChange,
}: PremiumRequiredModalProps) {
    const t = useTranslations();

    const router = useRouter();

    const handleUpgrade = () => {
        router.push("/premium");
        onOpenChange(false);
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>
                        {t("events.premiumRequiredTitle")}
                    </DialogTitle>
                    <DialogDescription>
                        {t("events.premiumRequiredBody")}
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button
                        variant="outline"
                        onClick={() => onOpenChange(false)}
                    >
                        {t("common.cancel")}
                    </Button>
                    <Button onClick={handleUpgrade}>
                        {t("events.premiumUpgrade")}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
